import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';
import PhotoSwipe from './photoswipe.esm.js';
import PhotoSwipeVideoPlugin from './photoswipe-video-plugin.esm.js';

const arrowPrevSVG = `<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path></svg>`;
const arrowNextSVG = `<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path></svg>`;
const closeSVG = `<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"></path></svg>`;

const lightbox = new PhotoSwipeLightbox({
	gallery: '.photoswipe-gallery',
	children: '.photoswipe-gallery__item:not(.photoswipe-gallery__item--hidden)',
	pswpModule: PhotoSwipe,
	showHideAnimationType: 'none',
	bgOpacity: 1,
	zoom: true,
	arrowPrevSVG: arrowPrevSVG,
	arrowNextSVG: arrowNextSVG,
	closeSVG: closeSVG,
});
new PhotoSwipeVideoPlugin(lightbox, {});

lightbox.init();

document
	.querySelectorAll('button.product__media-toggle, [data-media-slide-id]')
	.forEach((button) => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (button.closest('.product__media-item')) filterProductMedia();
			const mediaId =
				button.getAttribute('data-media-id') || button.getAttribute('data-media-slide-id');
			if (mediaId.includes('-font-options')) {
				openFontOptionsModal(button);
			} else {
				const photoswipeItem = document.querySelector(
					`.photoswipe-gallery__item[data-media-reference-id="${mediaId}"]`,
				);
				window.queueMicrotask(() => {
					photoswipeItem.click();
				});
			}
		});
	});

lightbox.on('close', () => {
	const mediaSrc = document
		.querySelector('.pswp__item[aria-hidden="false"] img, .pswp__item[aria-hidden="false"] video')
		.src.replace('https:', '');
	const allMedia = [
		...document.querySelectorAll(
			'.product__media-wrapper media-gallery slider-component.slider-mobile-gutter--not-full-width .product__media-list li.product__media-item',
		),
	];
    const pswpGalleryItem =
  		document.querySelector(`.photoswipe-gallery__item[href="${mediaSrc}"]`) ||
  		document.querySelector(`.photoswipe-gallery__item[href="https:${mediaSrc}"]`);
	const closedMediaId = pswpGalleryItem.getAttribute('data-media-reference-id');

	if (window.innerWidth >= 750) {
		const activeMedia = allMedia.filter(
			(media, index) => window.getComputedStyle(media).display !== 'none' && index !== 0,
		);
		const activeThumb = activeMedia.find(
			(el) =>
				el.querySelector('.product__media-toggle')?.getAttribute('data-media-id') === closedMediaId,
		);
		if (!activeThumb) return;
		activeMedia.forEach((el) => el.classList.remove('active-thumbnail'));
		if (activeThumb.querySelector('deferred-media')) {
			activeThumb.querySelector('.deffered-media-toggle').click();
		} else {
			activeThumb.querySelector('img').click();
		}
	} else {
		const activeMedia = allMedia.filter(
			(media) => window.getComputedStyle(media).display !== 'none',
		);
		const activeThumb = activeMedia.find(
			(el) =>
				el.querySelector('.product__media-toggle').getAttribute('data-media-id') === closedMediaId,
		);
		activeThumb && activeThumb.scrollIntoViewIfNeeded();
	}
});

// Remove controls and add loop to video
lightbox.on('contentActivate', ({ content }) => {
  // content becomes active (the current slide)
	const videoEl = content.element;
	videoEl.removeAttribute('controls');
	videoEl.setAttribute('loop', '');
	videoEl.setAttribute('muted', '');
});

function filterProductMedia() {
	const allMedia = [
		...document.querySelectorAll(
			'.product__media-wrapper media-gallery slider-component.slider-mobile-gutter--not-full-width .product__media-list li.product__media-item',
		),
	];

	const activeMedia = allMedia.filter((media) => window.getComputedStyle(media).display !== 'none');

	const activeMediaIds = activeMedia.map((media) => {
		return media.querySelector('button.product__media-toggle')?.getAttribute('data-media-id');
	});

	document
		.querySelectorAll('.photoswipe-gallery.photoswipe-gallery--main .photoswipe-gallery__item')
		.forEach((item) => {
			const mediaId = item.getAttribute('data-media-reference-id');
			if (!activeMediaIds.includes(mediaId)) {
				item.classList.add('photoswipe-gallery__item--hidden');
			} else {
				item.classList.remove('photoswipe-gallery__item--hidden');
			}
		});
}

function openFontOptionsModal(button) {
	const wrapper = button.closest('modal-opener');
	if (!wrapper) return;

	const image = wrapper.querySelector('img.js-general-product-img');
	if (!image) return;

	const options = {
		dataSource: [
			{
				src: image.src,
				width: 600,
				height: 600,
			},
		],
		showHideAnimationType: 'none',
		bgOpacity: 1,
		zoom: true,
		arrowPrevSVG: arrowPrevSVG,
		arrowNextSVG: arrowNextSVG,
		closeSVG: closeSVG,
	};
	options.index = 0;
	const pswp = new PhotoSwipe(options);
	pswp.init();
}
